import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import  '../src/styles/global.scss' ;

ReactDOM.render(
  <App />,
  document.getElementById('root')
);
